<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<kt-popup-notification></kt-popup-notification>
<router-outlet></router-outlet>